import { createFileRoute } from '@tanstack/react-router';
import { NotificationSettingsScreen } from '../features/settings/NotificationSettings.tsx';

export const Route = createFileRoute('/settings_/notifications')({
  component: NotificationSettingsScreen,
});
